export const TYPES = {
  PRIVACY: 'PRIVACY',
  IMPRESSIUM: 'IMPRESSIUM',
  COOKIES_TERMS: 'COOKIES_TERMS',
  CONTACT_US: 'CONTACT_US',
  FAQ: 'FAQ',
  ERROR: 'ERROR'
}

export const privacyAction = () => ({
  type: TYPES.PRIVACY,
})

export const impressiumAction = () => ({
  type: TYPES.IMPRESSIUM,
})

export const cookiesAction = () => ({
  type: TYPES.COOKIES_TERMS,
})

export const faqAction = () => ({
  type: TYPES.FAQ
})

export const contactUsAction = () => ({
  type: TYPES.CONTACT_US
})

export const errorAction = () => ({
  type: TYPES.ERROR
})


// WEBPACK FOOTER //
// ./src/actions/privacyPolicy.js